import(/* webpackMode: "eager" */ "C:\\react\\lakeeshop\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-plus-jakarta-sans\",\"display\":\"swap\"}],\"variableName\":\"plusJakartaSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "C:\\react\\lakeeshop\\node_modules\\sonner\\dist\\index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\react\\lakeeshop\\src\\components\\providers\\IdleLockProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\react\\lakeeshop\\src\\components\\providers\\ReduxProvider.tsx");
;
import(/* webpackMode: "eager" */ "C:\\react\\lakeeshop\\src\\styles\\tailwind.css");
